export default {
    AGENDADA: 'Agendado',
    LANCES: 'Lances',
    HABILITAÇÃO: 'Habilitação',
    RECURSO: 'Recurso',
    'APURAÇÃO DE PROPOSTAS': 'Apuração de Propostas',
    CREDENCIAMENTO: 'Credenciamento',
    'LANÇAMENTO DE PROPOSTAS': 'Lançamento de Propostas',
    'ADJUDICAÇÃO': 'Adjudicação',
    'AGUARDANDO ABERTURA DA SESSÃO': 'Aguardando Abertura da Sessão',
    'AGUARDANDO ABERTURA DE PROPOSTAS': 'Aguardando Abertura de Propostas',
    'NEGOCIAÇÃO': 'Negociação',
    'ABERTURA DE VISTAS': 'Abertura de Vistas'
}
